import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 300,
  "& > img": {
    width: 250,
    height: 200,
  },
}));

export const EmptyTitle = styled("span")(() => ({
  color: colors.gray500,
  textAlign: "center",
  font: "600 22px Manrope",
  lineHeight: "28px",
}));

export const EmptySubtitle = styled("span")(() => ({
  color: colors.gray500,
  textAlign: "center",
  font: "400 16px Manrope",
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));
